import { RouterState } from 'connected-react-router';
import { useSelector } from 'react-redux';
import { History } from 'history';
import LocationState = History.LocationState;

const useRouterData = (): RouterState<LocationState> => {
    return useSelector(({ router }: PersistedStore) => router as RouterState<LocationState>);
};

export default useRouterData;
